import { ExtendedDomRect } from 'core-components/library/popup/helpers/calculatePosition'

interface IResult {
  popupCoords: DOMRect
  targetCoords: ExtendedDomRect
}

interface ISizes {
  width?: number
  height?: number
}

export const getSizes = (
  popupNode: HTMLDivElement,
  targetNode: HTMLDivElement,
  sizes: ISizes
): IResult => {
  const oldWidthSize = popupNode.style.width
  const oldHeightSize = popupNode.style.height

  const cloneNode = popupNode.cloneNode(true) as HTMLDivElement
  document.body.appendChild(cloneNode)
  // remove setting sized for calculate real dimension
  if (!sizes.width && oldWidthSize && oldWidthSize !== 'auto') {
    cloneNode.style.width = 'auto'
  }
  if (oldHeightSize && oldHeightSize !== 'auto') {
    cloneNode.style.height = 'auto'
  }

  let targetCoordsBase = targetNode.getBoundingClientRect()
  if (targetCoordsBase.width === 0) {
    const childNode = targetNode.children[0]
    const childNodeCoords = childNode?.getBoundingClientRect()
    // This is an absolute target (which is why targetNode's width is empty)
    if (childNodeCoords?.width) {
      targetCoordsBase = childNodeCoords
    }
  }

  const targetCoords: ExtendedDomRect = {
    ...JSON.parse(JSON.stringify(targetCoordsBase)),
    horizontalCenter: targetCoordsBase.left + (targetCoordsBase.right - targetCoordsBase.left) / 2,
    verticalCenter: targetCoordsBase.top + (targetCoordsBase.bottom - targetCoordsBase.top) / 2,
  }
  const popupCoords = cloneNode.getBoundingClientRect()

  cloneNode.remove()

  return { targetCoords, popupCoords }
}
